// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"936e8b5a","166":"bfbb0a7c","237":"17c0daf2","366":"bfbb0a7c","570":"a262f160","745":"013a7b73"}[chunkId] + ".chunk.css";
};